import './style.scss';
import jQuery from 'jquery';

jQuery(function ($) {
  $('.prvb-faq-list--accordion .prvb-faq__q').on('click', function () {

    $(this).next().slideToggle(300, 'linear');

    $(this).toggleClass('is-open');
  })
})